export default __webpack_public_path__ + "img/e58845e535465948d9972b88c0cf7f85.svg";